const WELCOME_ROUTES = {
	path: "welcome",
	name: "welcome",
	component: () => import("@/views/pages/Dashboard/DashboardPage.vue"),
};

export default WELCOME_ROUTES;
